/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteDeliveryZoneMutationVariables = Exact<{
  id: string;
}>;


export type DeleteDeliveryZoneMutation = { delete_delivery_zone_by_pk: { id: string } | null };


export const DeleteDeliveryZoneDocument = /*#__PURE__*/ gql`
    mutation DeleteDeliveryZone($id: uuid!) {
  delete_delivery_zone_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteDeliveryZoneMutationFn = Apollo.MutationFunction<DeleteDeliveryZoneMutation, DeleteDeliveryZoneMutationVariables>;

/**
 * __useDeleteDeliveryZoneMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryZoneMutation, { data, loading, error }] = useDeleteDeliveryZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeliveryZoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryZoneMutation, DeleteDeliveryZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryZoneMutation, DeleteDeliveryZoneMutationVariables>(DeleteDeliveryZoneDocument, options);
      }
export type DeleteDeliveryZoneMutationHookResult = ReturnType<typeof useDeleteDeliveryZoneMutation>;
export type DeleteDeliveryZoneMutationResult = Apollo.MutationResult<DeleteDeliveryZoneMutation>;
export type DeleteDeliveryZoneMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryZoneMutation, DeleteDeliveryZoneMutationVariables>;